import type { FC } from 'react';
import { Table } from './Table';

type Props = {
  embedded?: boolean;
};

export const Leaderboard: FC<Props> = ({ embedded = false }) => {
  return <Table embedded={embedded} />;
};
